import { ref } from "vue";

import store from "../state/store"
import useSortData from './useSortData';

export default function useOccasions() {

    const isPublic = ref("")
    const search = ref("")
    const occasionTypeId = ref("");
    const occasionDateType = ref("");
    const perPage = ref(20)
    const loading = ref(false)


    const getOccasions = (url = null) => {
        store.dispatch("getOccasions", {
            url,
            search: search.value,
            occasionTypeId: occasionTypeId.value,
            occasionDateType: occasionDateType.value,
            is_public: isPublic.value,
            per_page: perPage.value,
            sort_field: sortField.value,
            sort_direction: sortDirection.value,
        })
    }

    const { sortField, sortDirection, sortData } = useSortData(getOccasions);

    const sortOccasions = (field) => {
        sortData(field);
        getOccasions();
    };


    return {
        isPublic,
        search,
        occasionTypeId,
        occasionDateType,
        perPage,
        sortField,
        sortDirection,
        loading,
        getOccasions,
        sortOccasions,
    }
}